export default function juveSearch() {
    const filterLink = document.querySelector('.js-use-filter');
    const resetLink = document.querySelector('.js-reset-filter');
    const form = document.querySelector('.js-search-form');
    const formFilters = [...document.querySelectorAll('.js-search-checkbox')];
    const postsFields = [...document.querySelectorAll('.js-post-checkbox')];
    const usePostsField = document.querySelector('.js-use-posts-field');
    const usePostsInput = document.querySelector('.js-use-posts');
    const clearIcon = document.querySelector('.js-clear-icon');
    const searchInput = document.querySelector('.js-search-input');

    function setHiddenInputFalse(formFilter) {
        const hiddenInputName = formFilter.name.replace('-field', '');
        const hiddenInput = document.querySelector(`[data-name=${hiddenInputName}]`);
        if (hiddenInput) {
            hiddenInput.value = formFilter.checked ? 1 : 0;
        }
    }

    const showClearIcon = () => {
        if (searchInput.value.length) {
            clearIcon.classList.add('show');
            return;
        }

        clearIcon.classList.remove('show');
    };

    const deactivateUsePostsFilter = () => {
        const activePostFilters = postsFields.filter(postField => postField.checked);
        if (!activePostFilters.length) {
            usePostsField.checked = false;
            usePostsInput.value = 0;
        }
    };

    if (usePostsField) {
        usePostsField.addEventListener('change', () => {
            usePostsInput.value = usePostsField.checked ? 1 : 0;
            postsFields.forEach((filter) => {
                // eslint-disable-next-line no-param-reassign
                if (!filter.checked && usePostsField.checked) {
                    // eslint-disable-next-line no-param-reassign
                    filter.checked = true;
                }
                if (filter.checked && !usePostsField.checked) {
                    // eslint-disable-next-line no-param-reassign
                    filter.checked = false;
                }
                setHiddenInputFalse(filter);
            });
        });
    }

    formFilters.forEach((formFilter) => {
        formFilter.addEventListener('change', () => {
            setHiddenInputFalse(formFilter);

            if (formFilter.name === 'use-top-employer-field' || formFilter.name === 'use-rankings-field') return;

            if (formFilter.checked && !usePostsField.checked) {
                // eslint-disable-next-line no-param-reassign
                usePostsField.checked = true;
            }
            deactivateUsePostsFilter();
        });
    });

    if (filterLink) {
        filterLink.addEventListener('click', () => {
            form.submit();
        });
    }

    if (resetLink) {
        resetLink.addEventListener('click', () => {
            formFilters.forEach((filter) => {
                if (!filter.checked) {
                    // eslint-disable-next-line no-param-reassign
                    filter.checked = true;
                    filter.dispatchEvent(new Event('change'));
                }
            });
        });
    }

    if (clearIcon && searchInput) {
        showClearIcon();
        searchInput.addEventListener('change', showClearIcon);
        searchInput.addEventListener('keyup', showClearIcon);
        clearIcon.addEventListener('click', () => {
            searchInput.value = '';
            showClearIcon();
            searchInput.focus();
        });
    }
}
